import { DeliveryStatus } from "../core/api/models";

export class DeliveryStatusTypesUiDto {
    type?: DeliveryStatus;
    color?: string;
}

const styles = getComputedStyle(document.documentElement);

export const DeliveryStatusTypesUi: DeliveryStatusTypesUiDto[] = [
    {
        type: DeliveryStatus.Unknown,
        color: "#071BE7"
    },
    {
        type: DeliveryStatus.SentAndReceivedbyPhone,
        color: styles.getPropertyValue('--color-success')
    },
    {
        type: DeliveryStatus.HaveNotReceivedToPhone,
        color: styles.getPropertyValue('--color-danger')
    },
    {
        type: DeliveryStatus.SentToItc,
        color: styles.getPropertyValue('--color-blue')
    },
    {
        type: DeliveryStatus.ReceivedByItc,
        color: styles.getPropertyValue('--color-info')
    },
    {
        type: DeliveryStatus.DidNotReceiveToItc,
        color: "#435290"
    },
    {
        type: DeliveryStatus.NotReceivebyServer,
        color: "#E5EC0D"
    },
    {
        type: DeliveryStatus.ErrorInSending,
        color: "#628EA4"
    },
    {
        type: DeliveryStatus.WaitingForSend,
        color: "#14859A"
    },
    {
        type: DeliveryStatus.Sent,
        color: "#EF45F8"
    },
    {
        type: DeliveryStatus.NotSent,
        color: "#F34305"
    },
    {
        type: DeliveryStatus.IsSending,
        color: "#8BDFFA"
    },
    {
        type: DeliveryStatus.BlackList,
        color: styles.getPropertyValue('--color-slate')
    },
    {
        type: DeliveryStatus.SmsIsFilter,
        color: "#A64A71"
    },
    {
        type: DeliveryStatus.WaitingForConfirmation,
        color: "#F75813"
    },
    {
        type: DeliveryStatus.NotEnoughBalance,
        color: "#4540FE"
    },
    {
        type: DeliveryStatus.TextIsEmpty,
        color: "#6EA160"
    },
    {
        type: DeliveryStatus.InvalidUserOrPassword,
        color: "#ADA6FE"
    },
    {
        type: DeliveryStatus.InvalidSender,
        color: "#F4AF3D"
    },
    {
        type: DeliveryStatus.InvalidMobile,
        color: styles.getPropertyValue('--color-warning')
    },
    {
        type: DeliveryStatus.Stored,
        color: "#8D703A"
    },
    {
        type: DeliveryStatus.BlackListTable,
        color: "#1F69AF"
    },
    {
        type: DeliveryStatus.Rejected,
        color: "#0CBF63"
    },
    {
        type: DeliveryStatus.SmsIdNotFound,
        color: "#1D591F"
    },
    {
        type: DeliveryStatus.InQueue,
        color: "#07BC5F"
    },
    {
        type: DeliveryStatus.InvalidSmsText,
        color: "#9B58B7"
    },
    {
        type: DeliveryStatus.SmsTextContainLink,
        color: "#148B15"
    },
    {
        type: DeliveryStatus.PacketGreaterThan100,
        color: "#FDE3D8"
    },
    {
        type: DeliveryStatus.MessagesCountAndNumberCountNotMatch,
        color: "#B1C0C7"
    },
    {
        type: DeliveryStatus.InvalidSendTime,
        color: "#457C2D"
    },
    {
        type: DeliveryStatus.MessageCountAndCodingCountNotMatch,
        color: "#E040C9"
    },
    {
        type: DeliveryStatus.OperatorNotSupport,
        color: "#630214"
    },
    {
        type: DeliveryStatus.InvalidGroupPrice,
        color: "#6C9259"
    },
    {
        type: DeliveryStatus.CodingNotSupport,
        color: "#503EEB"
    },
    {
        type: DeliveryStatus.PrivateNumberInActive,
        color: "#14E542"
    },
    {
        type: DeliveryStatus.PrivateNumberExpired,
        color: "#20A9AE"
    },
    {
        type: DeliveryStatus.NotSupportNumberFromOperator,
        color: "#41A2EA"
    },
    {
        type: DeliveryStatus.IllegalSendTime,
        color: "#5EBF48"
    },
    {
        type: DeliveryStatus.CanceledFromReceiver,
        color: "#B3258B"
    },
    {
        type: DeliveryStatus.InvalidCoding,
        color: "#15A4B2"
    },
    {
        type: DeliveryStatus.CanceledFromOperator,
        color: "#D0003B"
    },
    {
        type: DeliveryStatus.ExpiredFromOperator,
        color: "#6E9610"
    },
    {
        type: DeliveryStatus.RejectFromOperator,
        color: "#7EA4DA"
    },
    {
        type: DeliveryStatus.UserNameNotFound,
        color: "#99A259"
    },
    {
        type: DeliveryStatus.UserExpired,
        color: "#DF8152"
    },
    {
        type: DeliveryStatus.InActiveUser,
        color: "#073874"
    },
    {
        type: DeliveryStatus.UdhIsWrong,
        color: "#D0FAE3"
    },
    {
        type: DeliveryStatus.OperatorSystemError,
        color: "#8EEB63"
    },
    {
        type: DeliveryStatus.NotAccess,
        color: "#4B4DB1"
    },
    {
        type: DeliveryStatus.RejectByItc,
        color: "#860D7D"
    },
    {
        type: DeliveryStatus.InvalidRequest,
        color: "#F77260"
    },
    {
        type: DeliveryStatus.PrivateNumberIsBlocked,
        color: "#35654B"
    },
    {
        type: DeliveryStatus.OperatorNotAvailable,
        color: "#DF70B7"
    },
    {
        type: DeliveryStatus.InvalidSmartAdsId,
        color: "#DC24ED"
    },
    {
        type: DeliveryStatus.NotCompletedSmartRequest,
        color: "#CCAFD7"
    },
    {
        type: DeliveryStatus.SmartReqeustExpired,
        color: "#B275A8"
    }
];